import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { SearchResults } from '../models/search.types';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  search(q: string) {
    const params = new HttpParams().set('q', q);
    return this.http.get<SearchResults>(`${this.apiUrl}/backoffice/search`, { params });
  }
}
